import { useEffect } from "react";

import { CallCenterHelper } from "@/Common/Helpers/CallCenterHelper";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { CallCenterUserConnectionState } from "@/Common/Models/CallCenter/CallCenterUserConnectionState";
import { CallCenterLoginPopup } from "./CallCenterLoginPopup";
import { WindowContainer } from "./WindowContainer";

function logoutHandler(): void {
    CallCenterHelper.logoutWithBeaconAsync();
}

function CallCenterMain(): JSX.Element {
    useEffect(() => {
        sessionStore.initializeCallCenterNotificationHandler();
        sessionStore.CallCenter_SessionId = GuidHelper.NewGuid();
        // Login on mount and add eventlistener for beforeunload event to handle component unloading
        CallCenterHelper.loginAsync({ isInitial: true });
        window.addEventListener("beforeunload", logoutHandler);

        // Logout and remove eventlistener for beforeunload event when component unmounts
        return () => {
            CallCenterHelper.logoutWithBeaconAsync();
            window.removeEventListener("beforeunload", logoutHandler);
        };
    }, []);

    if (sessionStore.CallCenter_UserConnectionState === CallCenterUserConnectionState.Connected) {
        return (
            <WindowContainer userState={sessionStore.currentCallCenterUserState} />
        );
    }

    if (sessionStore.CallCenter_ShowLoginAccountPopup) {
        return (
            <CallCenterLoginPopup credentials={sessionStore.CallCenter_Credentials} />
        );
    }

    return null;
}

export { CallCenterMain };
